import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';
import { AppRoutes } from '../../App/routes';

export const collectionsRoot = 'collections';
export const collectionsOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${collectionsRoot}`;
export const COLLECTION_ROUTE_PARAMS = {
  collectionName: 'collectionName',
};
export const collectionsDetailRoute = `${collectionsOverviewRoute}/:${COLLECTION_ROUTE_PARAMS.collectionName}/edit`;
